module.exports = __webpack_public_path__ + "assets/img/kv-ed789cd8.jpg";